export default "__VITE_ASSET__11625136__"